import { useEffect, useRef, useState } from 'react'
import { CommonAxiosGet, CommonAxiosPost } from '../../../CommonUtils/CommonAxios';
import { config } from '../../../CommonUtils/CommonURLS';
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik';
import * as bie from "react-bootstrap";
import Swal from 'sweetalert2';
import { failureAlert, InfoAlert } from '../../../CommonUtils/SweetAlerts';
import allowNumbersOnly from '../../../CommonUtils/CommonValidations';
import moment from 'moment';
import { GetMediumList } from '../../../Reducers/AffiliationCommonservice';
import { useSelector } from 'react-redux';
import CommonReactTable from '../../../CommonUtils/CommonReactTable';
import { AC_YEAR_OLD } from '../../../CommonUtils/contextVariables';
import { useLocation } from 'react-router-dom';
import { FaFilePdf } from 'react-icons/fa';
import { openPdfInNewTab } from '../../../CommonUtils/CommonServices';


export default function AfflProceedConfrmDetails({ onNext, setIsSecondTabSubmitted }) {
    const location = useLocation();
    const Type = location?.state?.type || "";
    const MediumData = useSelector((state) => state?.commonMastersReducer?.Medium);
    const CollegeCode = useSelector((state) => state?.commonMastersReducer?.CollegeCode);
    const acYear = sessionStorage.getItem('ac_year');
    const [renewalCourses, setRenewalCourses] = useState([]);
    const [existingCourses, setExistingCourses] = useState([]);
    const [newCourse, setNewCourse] = useState([]);
    const [newCourseConfirm, setNewCourseConfirm] = useState([]);
    const [ffcaDataFlag, setFfcaDataFlag] = useState(false);



    const userId = (sessionStorage?.getItem('user_id'))

    const userid = (sessionStorage?.getItem('user_id') || "").startsWith('ffca_') ? sessionStorage?.getItem('user_id').split('_')[1] : sessionStorage?.getItem('user_id');

    const Colcodecondition = userId.startsWith("ffca") ? userid : CollegeCode;

    const hasFetchedData = useRef(false);
    const ProeedConfirmdetailsFormik = useFormik({
        initialValues: {
            collCode: Colcodecondition,
            acYear: acYear,
            existing: [],
            newCourses: []

        },
        enableReinitialize: true,


        onSubmit: (values) => {

            let isValid = true;
            let rowErrors = [];

            // Initialize arrays to track missing fields for each course type
            let existingCourseErrors = [];
            let newCourseErrors = [];

            // Validate Existing Courses
            console.log("existing?.length >>", values?.existing?.length);
            if (values.existing?.length > 0) {
                values.existing?.forEach((course, index) => {
                    let missingFields = [];
                    // Validation logic for existing courses
                    if (course.univCourseApproved === false || course.univCourseApproved === 'false') {
                        return;
                    }
                    if (!course.mediumCode) missingFields.push("Medium Code");
                    if (!course.graduationLevel) missingFields.push("Graduation Level");
                    if (!course.univCourseApproved) missingFields.push("University Course Approved");
                    if (!course.intakeApprovedCompetentAuthority) missingFields.push("Intake Approved Competent Authority");
                    if (course.univCourseApproved === true || course.univCourseApproved === 'true') {
                        if (!course.afflNature) missingFields.push("Affiliation Nature");

                        // if (!course.afflValidUpto) missingFields.push("Affiliation Valid Upto");
                        if (!userId.startsWith("ffca") && !course.afflValidUpto) {
                            missingFields.push("Affiliation Valid Upto");
                        }


                        if (!course.finalSanctionIntake) missingFields.push("Final Sanction Intake");
                        if (!course.finalNoSection) missingFields.push("Final Number of Sections");
                        if (!course.courseDeficiencies) missingFields.push("Course Deficiencies");
                        else if (course.courseDeficiencies === true || course.courseDeficiencies === 'true') {
                            if (!course.deficienciesReason) missingFields.push("Deficiencies Reason");
                        }
                    }

                    if (missingFields?.length > 0) {
                        existingCourseErrors.push({ row: index + 1, missingFields });
                        isValid = false;
                    }
                });
            }

            // Validate New Courses
            if (values.newCourses?.length > 0) {
                values.newCourses.forEach((course, index) => {
                    let missingFields = [];
                    // Validation logic for new courses
                    if (!course.mediumCode) missingFields.push("Medium Code");
                    if (!course.graduationLevel) missingFields.push("Graduation Level");
                    if (!course.courseDeficiencies) missingFields.push("Course Deficiencies");
                    if (!course.campusType) missingFields.push("Campus Type");

                    if (course.courseDeficiencies === false || course.courseDeficiencies === 'false') {
                        if (!course.intakeApprovedCompetentAuthority) missingFields.push("Intake Approved Competent Authority");
                        if (!course.univCourseApproved) missingFields.push("University Course Approved");

                        if (course.univCourseApproved === true || course.univCourseApproved === 'true') {
                            if (!course.afflNature) missingFields.push("Affiliation Nature");
                            if (!userId.startsWith("ffca") && !course.afflValidUpto) {
                                missingFields.push("Affiliation Valid Upto");
                            }


                            if (!course.finalSanctionIntake) missingFields.push("Final Sanction Intake");
                            if (!course.finalNoSection) missingFields.push("Final Number of Sections");
                        }
                    }

                    if (missingFields?.length > 0) {
                        newCourseErrors.push({ row: index + 1, missingFields });
                        isValid = false;
                    }
                });
            }

            // Show error messages for missing fields
            if (existingCourseErrors?.length > 0) {
                let errorMessage = `At Existing Course Details Confirmation Table:`;
                existingCourseErrors?.forEach((error) => {
                    errorMessage += `\nAt row ${error.row}, please enter: ${error.missingFields.join(", ")}`;
                });
                Swal.fire({
                    title: 'Existing Course Missing Fields',
                    text: errorMessage,
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            }

            if (newCourseErrors?.length > 0) {
                let errorMessage = `At New Course Details Confirmation Table:`;
                newCourseErrors?.forEach((error) => {
                    errorMessage += `\nAt row ${error.row}, please enter: ${error.missingFields.join(", ")}`;
                });
                Swal.fire({
                    title: 'New Course Missing Fields',
                    text: errorMessage,
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            }

            // Proceed with submission if everything is valid
            if (isValid) {
                // Process existing courses
                values.existing.forEach((course) => {
                    course.mediumCode = parseInt(course.mediumCode) || course.mediumCode;
                    course.finalSanctionIntake = parseInt(course.finalSanctionIntake) || course.finalSanctionIntake;
                    course.finalNoSection = parseInt(course.finalNoSection) || course.finalNoSection;
                    course.intakeApprovedCompetentAuthority = parseInt(course.intakeApprovedCompetentAuthority) || course.intakeApprovedCompetentAuthority;
                    course.approve = course.approve === 'true';
                    course.deficienciesReason = parseInt(course.deficienciesReason) || course.deficienciesReason;
                });

                // Process new courses
                if (values.newCourses?.length > 0) {
                    values.newCourses.forEach((course) => {
                        course.mediumCode = course.mediumCode || "";
                        course.graduationLevel = course.graduationLevel || "";
                        course.courseDeficiencies = course.courseDeficiencies || "";
                        course.campusType = course.campusType || "";
                        course.intakeApprovedCompetentAuthority = parseInt(course.intakeApprovedCompetentAuthority) || course.intakeApprovedCompetentAuthority;
                        course.univCourseApproved = course.univCourseApproved || "";
                        course.afflNature = course.afflNature || "";
                        course.afflValidUpto = course.afflValidUpto || "";
                        course.finalSanctionIntake = parseInt(course.finalSanctionIntake) || course.finalSanctionIntake;
                        course.finalNoSection = parseInt(course.finalNoSection) || course.finalNoSection;
                    });
                } else {
                    values.newCourses = [];
                }
                Swal.fire({
                    text: 'Are you sure you want to submit?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, submit it!',
                    cancelButtonText: 'No, cancel!',
                    backdrop: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        const url = `${config.url.API_URL}saveCourseDetailsCnfrm`;
                        CommonAxiosPost(url, values).then((res) => {
                            if (res?.data?.scode === '01') {
                                Swal.fire({
                                    title: res?.data?.sdesc,
                                    backdrop: false
                                }).then((res1) => {
                                    if (res1?.isConfirmed === true) {
                                        if (userId?.startsWith("ffca")) {
                                            window.location.reload();
                                        } else {
                                            NewCourseConfirmDataReport();
                                            GetExistingCoursesData();
                                            setIsSecondTabSubmitted(true);
                                            onNext(Type);
                                        }
                                    }
                                });
                            } else {
                                failureAlert(res?.data?.sdesc);
                            }
                        });
                    } else {
                        console.log('Submission canceled');
                    }
                });
            }
        }


    })
    function GetRenewalCoursesData() {
        let url = config.url.API_URL + `getRenewalCourses/` + Colcodecondition + "/" + acYear;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setRenewalCourses(res?.data?.getRenewalCourses)
                res?.data?.getRenewalCourses?.forEach((data, i) => {
                    ProeedConfirmdetailsFormik?.setFieldValue(`existing[${i}].courseId`, data?.course_id);
                    ProeedConfirmdetailsFormik?.setFieldValue(`existing[${i}].regSelf`, data?.reg_self);
                    ProeedConfirmdetailsFormik?.setFieldValue(`existing[${i}].courseAfflType`, data?.course_affl_type);
                });
            } else {
                setRenewalCourses([])

            }
        })
    }

    function GetExistingCoursesData() {
        let url = config.url.API_URL + `getExistingCourses/` + Colcodecondition + "/" + acYear;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                const courses = res?.data?.getExistingCourses || [];
                setExistingCourses(courses);
                res?.data?.getExistingCourses?.forEach((data, i) => {
                    const existValidDate = data?.affl_valid_upto && moment(data?.affl_valid_upto, 'DD/MM/YYYY', true).isValid() ? moment(data?.affl_valid_upto, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';

                    ProeedConfirmdetailsFormik?.setFieldValue(`existing[${i}].mediumCode`, data?.medium_code);
                    ProeedConfirmdetailsFormik?.setFieldValue(`existing[${i}].courseId`, data?.course_id);

                    ProeedConfirmdetailsFormik?.setFieldValue(`existing[${i}].graduationLevel`, data?.graduation_level);
                    ProeedConfirmdetailsFormik?.setFieldValue(`existing[${i}].intakeApprovedCompetentAuthority`, data?.intake_approved_competent_authotity);
                    ProeedConfirmdetailsFormik?.setFieldValue(`existing[${i}].univCourseApproved`, data?.univ_course_approved?.toString());
                    ProeedConfirmdetailsFormik?.setFieldValue(`existing[${i}].afflNature`, data?.course_affl_type);
                    ProeedConfirmdetailsFormik?.setFieldValue(`existing[${i}].finalSanctionIntake`, data?.final_sanction_intake);
                    ProeedConfirmdetailsFormik?.setFieldValue(`existing[${i}].finalNoSection`, data?.final_no_section);
                    ProeedConfirmdetailsFormik?.setFieldValue(`existing[${i}].deficienciesReason`, data?.deficiencies_reason);

                    ProeedConfirmdetailsFormik?.setFieldValue(`existing[${i}].courseDeficiencies`, data?.course_deficiencies?.toString() ?? '');
                    ProeedConfirmdetailsFormik?.setFieldValue(`existing[${i}].afflValidUpto`, existValidDate ?? '');
                });
            } else {
                setExistingCourses([]);
            }
        })
    }
    function NewCourseDataReport() {
        let url = config.url.API_URL + `getnewCourses/` + Colcodecondition + "/" + acYear;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setNewCourse(res?.data?.getnewCourses)
            } else {
                setNewCourse([])

            }
        })
    }

    function NewCourseConfirmDataReport() {
        let url = config.url.API_URL + `getnewCoursesCnfrm/` + Colcodecondition + "/" + acYear;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setNewCourseConfirm(res?.data?.getnewCoursesCnfrm)
                setFfcaDataFlag(true);
                res?.data?.getnewCoursesCnfrm?.forEach((data, i) => {


                    const newValidDate = res?.data?.getnewCoursesCnfrm[i]?.affl_valid_upto && moment(res?.data?.getnewCoursesCnfrm[i]?.affl_valid_upto, 'DD/MM/YYYY', true).isValid() ? moment(res?.data?.getnewCoursesCnfrm[i]?.affl_valid_upto, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;
                    ProeedConfirmdetailsFormik?.setFieldValue(`newCourses[${i}].courseId`, data?.course_id);
                    ProeedConfirmdetailsFormik?.setFieldValue(`newCourses[${i}].regSelf`, data?.reg_self);
                    ProeedConfirmdetailsFormik?.setFieldValue(`newCourses[${i}].courseAfflType`, data?.course_affl_type);
                    ProeedConfirmdetailsFormik?.setFieldValue(`newCourses[${i}].mediumCode`, data?.medium_code);
                    ProeedConfirmdetailsFormik?.setFieldValue(`newCourses[${i}].graduationLevel`, data?.graduation_level);
                    ProeedConfirmdetailsFormik?.setFieldValue(`newCourses[${i}].univCourseApproved`, data?.univ_course_approved?.toString());
                    ProeedConfirmdetailsFormik?.setFieldValue(`newCourses[${i}].intakeApprovedCompetentAuthority`, data?.intake_approved_competent_authotity);
                    ProeedConfirmdetailsFormik?.setFieldValue(`newCourses[${i}].afflNature`, data?.affl_nature);
                    ProeedConfirmdetailsFormik?.setFieldValue(`newCourses[${i}].courseDeficiencies`, data?.course_deficiencies?.toString());
                    ProeedConfirmdetailsFormik?.setFieldValue(`newCourses[${i}].afflValidUpto`, newValidDate ?? '');
                    ProeedConfirmdetailsFormik?.setFieldValue(`newCourses[${i}].finalSanctionIntake`, data?.final_sanction_intake);
                    ProeedConfirmdetailsFormik?.setFieldValue(`newCourses[${i}].finalNoSection`, data?.final_no_section);
                    ProeedConfirmdetailsFormik?.setFieldValue(`newCourses[${i}].campusType`, data?.campus_type);
                });

            } else {
                setNewCourseConfirm([])

            }
        })
    }

    const [ffcaNonOamdcStatusFlag, setFfcaNonOamdcStatusFlag] = useState(false);

    const [ffcaNonOamdcCoursesData, SetFfcaNonOamdcCoursesData] = useState([]);

    async function FFCANonOamdcCourseConfirmData() {
        let url = config.url.API_URL + `getffcanoncourses/` + Colcodecondition + "/" + acYear;
        const res = await CommonAxiosGet(url);
        if (res?.data?.status === true) {
            SetFfcaNonOamdcCoursesData(res?.data)
            setFfcaNonOamdcStatusFlag(true);
        } else {
            SetFfcaNonOamdcCoursesData([])
        }
    }
    const [ffcastatus, setFfcastatus] = useState('');

    async function GetFFCASubmissionStatus() {
        let url = config.url.API_URL + `ffcaStatus/` + Colcodecondition + "/" + acYear;
        const res = await CommonAxiosGet(url);
        if (res?.data?.status === true) {
            setFfcastatus(res?.data?.ffcaStatus)

        } else {
            setFfcastatus('')

        }
    }



    function GetFacultyDefPDf() {
        let url = config.url.API_URL + `getafflfacultydef/pdf/` + userid + "/" + acYear;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === 1) {
                openPdfInNewTab(res?.data?.data)
            } else {
                console.log("No Data Found")

            }
        })
    }

    useEffect(() => {
        if (!hasFetchedData.current) {
            GetFFCASubmissionStatus();
            FFCANonOamdcCourseConfirmData();
            GetRenewalCoursesData();
            GetExistingCoursesData();
            NewCourseDataReport();
            NewCourseConfirmDataReport();
            GetMediumList();
            hasFetchedData.current = true
        }

    }, [])

    let InfoMsg = "As per the Directions of the Higher Education Department, Conditional Affiliation Order cannot be given to New Courses. If Deficiencies are available, the CDC Dean shall not approve the New Course/Combination."
    const CourseDataReportColumns = [
        { Header: "Sl.no", accessor: (row, index) => index + 1, },
        {
            Header: <> Academic Program <br /> type</>, accessor: "course_group_desc",
            Cell: ({ row }) => <div className='text-left'> {row?.values?.course_group_desc ? row?.values?.course_group_desc : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },
        {
            Header: "Course /Program", accessor: "course_cat_name",
            Cell: ({ row }) => <div className='text-left'> {row?.values?.course_cat_name ? row?.values?.course_cat_name : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },
        {
            Header: "Branch/Combination", accessor: "course_name",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.course_name ? row?.values?.course_name : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "Medium", accessor: "name",
            Cell: ({ row }) => <div>{row?.values?.name ? row?.values?.name : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: <>Nature of Affiliation<br /> being Accorded</>,
            accessor: "course_affl_type",
            Cell: ({ row }) => <div>{row?.values?.course_affl_type ? row?.values?.course_affl_type : <b style={{ textAlign: 'center' }}>-</b>}</div>


        },
        {
            Header: !userId.startsWith("ffca")
                ? `University Approved Intake for Academic year ${AC_YEAR_OLD}`
                : `FFCA Recommended Intake for Academic year ${AC_YEAR_OLD}`,
            accessor: "final_sanction_intake", Cell: ({ row }) => <div>{row?.values?.final_sanction_intake ? row?.values?.final_sanction_intake : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: <>Intake Approved by<br /> Competent Authority as <br />Submitted by the College</>,
            accessor: "exst_course_competent_auth_intake_21", Cell: ({ row }) => <div>{row?.values?.exst_course_competent_auth_intake_21 ? row?.values?.exst_course_competent_auth_intake_21 : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },


        {
            Header: <>Approved No. of <br /> Sections as<br /> Submitted by College</>,
            accessor: "approv_no_of_sections", Cell: ({ row }) => <div>{row?.values?.approv_no_of_sections ? row?.values?.approv_no_of_sections : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },
        {
            Header: <> Intake being<br />requested by College  </>,
            accessor: "exst_course_requested_intake_21", Cell: ({ row }) => <div>{row?.values?.exst_course_requested_intake_21 ? row?.values?.exst_course_requested_intake_21 : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },
        {
            Header: !userId.startsWith("ffca")
                ? "Additional Number  of Sections being requested  (other than that are approved  by University in Previous AC Year)"
                : "Additional Number  of Sections being requested  (other than that are Recommended  by FFCA in Previous AC Year)",

            accessor: "addl_course_requested_sections_21", Cell: ({ row }) => <div>{row?.values?.addl_course_requested_sections_21 ? row?.values?.addl_course_requested_sections_21 : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },
        {
            Header: <>No. of Sections<br /> being Withdrawn</>, accessor: "withdraw_no_of_sections", Cell: ({ row }) => <div>{row?.values?.withdraw_no_of_sections ? row?.values?.withdraw_no_of_sections : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },
        {
            Header: <> Change of <br />Medium to </>,
            accessor: "medium_change_name", Cell: ({ row }) => <div>{row?.values?.medium_change_name ? row?.values?.medium_change_name : <b style={{ textAlign: 'center' }}>-</b>}</div>


        },
        {
            Header: <>Applying for <br />Permanent<br /> Affiliation</>,
            accessor: "affl_type_21", Cell: ({ row }) => <div>{row?.values?.affl_type_21 ? row?.values?.affl_type_21 : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },

    ]
    const FfcaExistingCoursesColumns = [
        { Header: "Sl.no", accessor: (row, index) => index + 1, },
        {
            Header: <> Academic Program <br /> type</>, accessor: "course_group_desc", Cell: ({ row }) => <div className='text-left'>{row?.values?.course_group_desc ? row?.values?.course_group_desc : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "Course /Program", accessor: "course_cat_name", Cell: ({ row }) => <div className='text-left'>{row?.values?.course_cat_name ? row?.values?.course_cat_name : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "Branch/Combination", accessor: "course_name", Cell: ({ row }) => <div className='text-left'>{row?.values?.course_name ? row?.values?.course_name : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "Medium", accessor: "name", Cell: ({ row }) => <div className='text-left'>{row?.values?.name ? row?.values?.name : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },
        {
            Header: "Level(UG / PG)",
            accessor: "graduation_level", Cell: ({ row }) => <div className='text-left'>{row?.values?.graduation_level ? row?.values?.graduation_level : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },
        {
            Header: 'Intake Approved by Competent Authority (Please refer to the Proceedings of the Competent Authority and enter the details)( CHE/AICTE/BCI/PCI/NCTE)',
            accessor: "intake_approved_competent_authotity", Cell: ({ row }) => <div className='text-left'>{row?.values?.intake_approved_competent_authotity ? row?.values?.intake_approved_competent_authotity : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },
        {
            Header: "Is FFCA Recommended Affiliation for this course and Combination",
            accessor: "univ_course_approved", Cell: ({ row }) => <div className='text-left'>{row?.values?.univ_course_approved ? row?.values?.univ_course_approved : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },

        {
            Header: "Nature of Affiliation being Recommended",
            accessor: "affl_nature",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.affl_nature ? row?.values?.affl_nature : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },

        {
            Header: `Intake being Recommended by FFCA for Academic year ${acYear}`,
            accessor: "final_sanction_intake",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.final_sanction_intake ? row?.values?.final_sanction_intake : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },
        {

            Header: `Number of Sections being Recommended by FFCA for Academic year ${acYear}`,
            accessor: "final_no_section",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.final_no_section ? row?.values?.final_no_section : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },

        {
            Header: "Are there any deficiencies that College shall fulfill for this course and combination",
            accessor: "course_deficiencies",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.course_deficiencies ? row?.values?.course_deficiencies : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },

        {
            Header: "Please state the List of the deficiencies",
            accessor: "deficiencies_reason",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.deficiencies_reason ? row?.values?.deficiencies_reason : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },


    ]

    const ExistingCoursesColumns = [
        { Header: "Sl.no", accessor: (row, index) => index + 1, },
        {
            Header: <> Academic Program <br /> type</>, accessor: "course_group_desc",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.course_group_desc ? row?.values?.course_group_desc : <b style={{ textAlign: 'center' }}>-</b>}</div>


        },
        {
            Header: "Course /Program", accessor: "course_cat_name",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.course_cat_name ? row?.values?.course_cat_name : <b style={{ textAlign: 'center' }}>-</b>}</div>


        },
        {
            Header: "Branch/Combination", accessor: "course_name",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.course_name ? row?.values?.course_name : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "Medium",
            accessor: (row, index) => (<>
                <Field type="hidden" name={`existing[${index}].courseId`} className="form-control" />
                <Field type="hidden" name={`existing[${index}].regSelf`} className="form-control" />
                <Field type="hidden" name={`existing[${index}].courseAfflType`} className="form-control" />
                <Field as="select" name={`existing[${index}].mediumCode`} className="form-control">
                    <option value=''>--SELECT--</option>
                    {MediumData && MediumData.map((rel, i) => (
                        <option value={rel?.medium_code}>{rel?.name}</option>
                    ))}
                </Field>
                <ErrorMessage name={`existing[${index}].mediumCode`} component="div" className="text-error" />

            </>),
        },
        {
            Header: "Level(UG / PG)",
            accessor: (row, index) => (<>
                <Field as="select" name={`existing[${index}].graduationLevel`} className="form-control">
                    <option value="">---select----</option>
                    <option value="UG">UG</option>
                    <option value="PG">PG</option>
                </Field>
                <ErrorMessage name={`existing[${index}].graduationLevel`} component="div" className="text-error" />

            </>),
        },
        {
            Header: 'Intake Approved by Competent Authority (Please refer to the Proceedings of the Competent Authority and enter the details)( CHE/AICTE/BCI/PCI/NCTE)',
            accessor: (row, index) => (<>
                <Field type="text" name={`existing[${index}].intakeApprovedCompetentAuthority`} onKeyPress={(e) => { allowNumbersOnly(e) }} className="form-control" maxLength="5" />
                <ErrorMessage name={`existing[${index}].intakeApprovedCompetentAuthority`} component="div" className="text-error" />
            </>),
        },
        {
            Header: !userId.startsWith("ffca")
                ? "Is University Approving Affiliation for this course and Combination"
                : "Is FFCA Recommending Affiliation for this course and Combination",
            accessor: (row, index) => (
                <>
                    <Field as="select" name={`existing[${index}].univCourseApproved`} className="form-control"
                        onChange={e => {
                            ProeedConfirmdetailsFormik?.setFieldValue(`existing[${index}].afflNature`, "");
                            ProeedConfirmdetailsFormik?.setFieldValue(`existing[${index}].afflValidUpto`, "");
                            ProeedConfirmdetailsFormik?.setFieldValue(`existing[${index}].finalSanctionIntake`, "");
                            ProeedConfirmdetailsFormik?.setFieldValue(`existing[${index}].finalNoSection`, "");
                            ProeedConfirmdetailsFormik?.setFieldValue(`existing[${index}].courseDeficiencies`, "");
                            ProeedConfirmdetailsFormik?.setFieldValue(`existing[${index}].deficienciesReason`, "");
                        }}>

                        <option value="">---select----</option>
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                    </Field>
                    <ErrorMessage name={`existing[${index}].univCourseApproved`} component="div" className="text-error" />

                </>
            ),
        },

        {
            Header: "Nature of Affiliation being Accorded",
            accessor: (row, index) => (<>
                {ProeedConfirmdetailsFormik?.values?.existing[index]?.univCourseApproved === "true" ?
                    <Field as="select" name={`existing[${index}].afflNature`} className="form-control">
                        <option value="">---select----</option>
                        <option value="Conditional">Conditional</option>
                        <option value="Temporary">Temporary</option>
                        <option value="Permanent">Permanent</option>
                    </Field> : ''}
                <ErrorMessage name={`existing[${index}].afflNature`} component="div" className="text-error" />

            </>

            ),
        },
        ...(!userId.startsWith("ffca") ? [


            {
                Header: "Affiliation Valid Upto",
                accessor: (row, index) => (<>
                    {ProeedConfirmdetailsFormik?.values?.existing[index]?.univCourseApproved === "true" ?
                        <Field type="date" name={`existing[${index}].afflValidUpto`} className="form-control"
                            onKeyDown={(e) => { e.preventDefault() }}
                            min={new Date().toISOString().split('T')[0]} /> : ''}
                    <ErrorMessage name={`existing[${index}].afflValidUpto`} component="div" className="text-error" />

                </>
                ),

            }] : []),


        {
            Header: !userId.startsWith("ffca")
                ? `Intake being Approved by University for Academic year ${acYear}`
                : `Intake being Recommended by FFCA for Academic year ${acYear}`,

            accessor: (row, index) => (<>
                {ProeedConfirmdetailsFormik?.values?.existing[index]?.univCourseApproved === "true" ?
                    <Field type="text" name={`existing[${index}].finalSanctionIntake`} className="form-control" onKeyPress={(e) => { allowNumbersOnly(e); }} maxLength="5" />
                    : ''}
                <ErrorMessage name={`existing[${index}].finalSanctionIntake`} component="div" className="text-error" />
            </>
            ),
        },
        {
            Header: !userId.startsWith("ffca")
                ? `Number of Sections being approved by University for Academic year ${acYear}`
                : `Number of Sections being Recommended by FFCA for Academic year ${acYear}`,

            accessor: (row, index) => (<>
                {ProeedConfirmdetailsFormik?.values?.existing[index]?.univCourseApproved === "true" ?

                    <Field type="text" name={`existing[${index}].finalNoSection`} onKeyPress={(e) => { allowNumbersOnly(e); }} className="form-control" maxLength="8" />
                    : ''}
                <ErrorMessage name={`existing[${index}].finalNoSection`} component="div" className="text-error" />

            </>

            ),
        },

        {
            Header: "Are there any deficiencies that College shall fulfill for this course and combination",
            accessor: (row, index) => (
                <>
                    {ProeedConfirmdetailsFormik?.values?.existing[index]?.univCourseApproved === "true" ?
                        <Field as="select" name={`existing[${index}].courseDeficiencies`} className="form-control"
                            onChange={(event) => {
                                ProeedConfirmdetailsFormik?.setFieldValue(`existing[${index}].deficienciesReason`, "");
                            }}
                        >
                            <option value="">---select----</option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </Field>
                        : ''}
                    <ErrorMessage name={`existing[${index}].courseDeficiencies`} component="div" className="text-error" />
                </>
            ),

        },

        {
            Header: "Please state the List of the deficiencies",
            accessor: (row, index) => (
                <>
                    {ProeedConfirmdetailsFormik?.values?.existing[index]?.courseDeficiencies === "true" && ProeedConfirmdetailsFormik?.values?.existing[index]?.univCourseApproved === "true" ?
                        < Field as="textarea" name={`existing[${index}].deficienciesReason`} className="form-control" maxLength="350" />
                        : ''}
                    <ErrorMessage name={`existing[${index}].deficienciesReason`} component="div" className="text-error" />
                </>
            ),
        },


    ]
    const NewCourseColumns = [
        {
            Header: "Sl.no",
            accessor: (row, index) => index + 1,
        },
        {
            Header: <> Academic Program  <br />Type  </>,
            accessor: "course_group_desc",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.course_group_desc ? row?.values?.course_group_desc : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },

        {
            Header: "Course /Program",
            accessor: "course_cat_name",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.course_cat_name ? row?.values?.course_cat_name : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },
        {
            Header: "Branch/Combination",
            accessor: "course_name",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.course_name ? row?.values?.course_name : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "Medium",
            accessor: "medium",
            Cell: ({ row }) => <div>{row?.values?.medium ? row?.values?.medium : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: <>Regular/<br />Self-Financed   </>,
            accessor: "reg_self",
        },
        {
            Header: <>Afiliation Permanent<br />/Temporary</>,
            accessor: "course_affl_type",
            Cell: ({ row }) => <div>{row?.values?.course_affl_type ? row?.values?.course_affl_type : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: <>Has competent Authority<br />( AICTE/CHE/BCI/PCI) <br />Approved this course<br /> for Academic year {acYear}  </>,
            accessor: "addl_course_competent_auth_appr_21",
        },
        {
            Header: <>Is this course <br />available in the L<br />atest EOP/EOA<br /> issued by the <br />competent Authority  </>,
            accessor: "addl_course_eoa_eop_21",
        }, {
            Header: <> If available Please <br />specify the Intake<br /> approved by<br /> competent Authority   </>,
            accessor: "addl_course_competent_auth_intake_21",
        },
        ///////////
        {
            // Header: <>Intake being Approved<br /> by University for<br /> Academic year {acYear}    </>,
            Header: !userId.startsWith("ffca")
                ? `Intake being Approved  by University for  Academic year ${acYear} `
                : `Intake being Recommended  by FFCA for  Academic year ${acYear} `,
            accessor: "addl_course_requested_intake_21",
        },
        {
            Header: <>Number of Sections<br /> being requested  </>,
            accessor: "approv_no_of_sections",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.approv_no_of_sections ? row?.values?.approv_no_of_sections : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },

        {
            Header: <>Campus Type</>,
            accessor: "campus_type",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.campus_type ? row?.values?.campus_type : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },

    ]

    const FfcaCourseConfirmColumns = [
        {
            Header: "Sl.no",
            accessor: (row, index) => index + 1,
        },
        {
            Header: "Academic Program  Type",
            accessor: "course_group_desc",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.course_group_desc ? row?.values?.course_group_desc : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },
        {
            Header: "Course /Program",
            accessor: "course_name",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.course_name ? row?.values?.course_name : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },

        {
            Header: "Medium",
            accessor: "name",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.name ? row?.values?.name : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },
        {
            Header: "Level(UG / PG)",
            accessor: "graduation_level",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.graduation_level ? row?.values?.graduation_level : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },

        {
            Header: "Are there any deficiencies that College shall fulfill for this course and combination",
            accessor: "course_deficiencies",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.course_deficiencies ? row?.values?.course_deficiencies : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },
        {
            Header: "Intake Recommended by Competent Authority (Please refer to the Proceedings of the Competent Authority and enter the details)( CHE/AICTE/BCI/PCI/NCTE)  ",
            accessor: "intake_approved_competent_authotity",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.intake_approved_competent_authotity ? row?.values?.intake_approved_competent_authotity : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },
        {
            Header: `Is FFCA Recommended Affiliation for this course and Combination`,
            accessor: "univ_course_approved",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.univ_course_approved ? row?.values?.univ_course_approved : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },
        {
            Header: "Nature of Affiliation being Recommended",
            accessor: "course_affl_type",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.course_affl_type ? row?.values?.course_affl_type : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },

        {
            Header: `Intake being Recommended by FFCA for Academic year ${acYear}`,
            accessor: "final_sanction_intake",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.final_sanction_intake ? row?.values?.final_sanction_intake : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },
        {

            Header: `Number of Sections being Recommended by FFCA for Academic year ${acYear}`,
            accessor: "final_no_section",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.final_no_section ? row?.values?.final_no_section : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },
        {
            Header: "Campus type",
            accessor: "campus_type",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.campus_type ? row?.values?.campus_type : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },

    ]
    const NewCourseConfirmColumns = [
        {
            Header: "Sl.no",
            accessor: (row, index) => index + 1,
        },

        {
            Header: "Academic Program  Type",
            accessor: "course_group_desc",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.course_group_desc ? row?.values?.course_group_desc : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },
        {
            Header: "Course/Program",
            accessor: "course_name",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.course_name ? row?.values?.course_name : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },

        {
            Header: "Medium",
            accessor: (row, index) => (<>
                <Field type="hidden" name={`newCourses[${index}].courseId`} className="form-control" />
                <Field type="hidden" name={`newCourses[${index}].regSelf`} className="form-control" />
                <Field type="hidden" name={`newCourses[${index}].courseAfflType`} className="form-control" />



                <Field as="select" name={`newCourses[${index}].mediumCode`} className="form-control">
                    <option value="">---select----</option>
                    {MediumData && MediumData?.map((rel, i) => (
                        <option value={rel?.medium_code}>{rel?.name}</option>
                    ))}
                </Field>
            </>),
        },
        {
            Header: "Level(UG / PG)",
            accessor: (row, index) => (
                <Field as="select" name={`newCourses[${index}].graduationLevel`} className="form-control">
                    <option value="">---select----</option>
                    <option value="UG">UG</option>
                    <option value="PG">PG</option>
                </Field>
            ),
        },

        {
            Header: "Are there any deficiencies that College shall fulfill for this course and combination",
            accessor: (row, index) => (
                <>
                    <Field as="select" name={`newCourses[${index}].courseDeficiencies`} className="form-control"
                        onChange={(event) => {
                            const value = event.target.value;
                            if (value === "true") {
                                InfoAlert(InfoMsg);
                            }
                            ProeedConfirmdetailsFormik?.setFieldValue(`newCourses[${index}].intakeApprovedCompetentAuthority`, "");
                            ProeedConfirmdetailsFormik?.setFieldValue(`newCourses[${index}].univCourseApproved`, "");

                        }}>
                        <option value="">---select----</option>
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                    </Field>
                </>
            ),
        },
        {
            Header: "Intake Approved by Competent Authority (Please refer to the Proceedings of the Competent Authority and enter the details)( CHE/AICTE/BCI/PCI/NCTE)  ",
            accessor: (row, index) => (<>
                {ProeedConfirmdetailsFormik?.values?.newCourses[index]?.courseDeficiencies === "false" ?
                    <Field type="text" name={`newCourses[${index}].intakeApprovedCompetentAuthority`} className="form-control" onKeyPress={(e) => { allowNumbersOnly(e) }} maxLength="5" />
                    : ''}</>

            ),
        },
        {
            Header: !userId.startsWith("ffca")
                ? `Is University Approving Affiliation for this course and Combination`
                : `Is FFCA Approving Affiliation for this course and Combination`,
            accessor: (row, index) => (
                <>
                    {ProeedConfirmdetailsFormik?.values?.newCourses[index]?.courseDeficiencies === "false" ?
                        <Field as="select" name={`newCourses[${index}].univCourseApproved`} className="form-control"
                            onChange={e => {
                                ProeedConfirmdetailsFormik?.setFieldValue(`newCourses[${index}].afflNature`, "");
                                ProeedConfirmdetailsFormik?.setFieldValue(`newCourses[${index}].afflValidUpto`, "");
                                ProeedConfirmdetailsFormik?.setFieldValue(`newCourses[${index}].finalSanctionIntake`, "");
                                ProeedConfirmdetailsFormik?.setFieldValue(`newCourses[${index}].finalNoSection`, "");
                            }}>

                            <option value="">---select----</option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </Field>

                        : ''}</>

            ),
        },
        {
            Header: "Nature of Affiliation being Accorded",
            accessor: (row, index) => (
                <>
                    {ProeedConfirmdetailsFormik?.values?.newCourses[index]?.univCourseApproved === "true" ?

                        <Field as="select" name={`newCourses[${index}].afflNature`} className="form-control" >
                            <option value="">---select----</option>

                            <option value="Temporary">Temporary</option>
                            <option value="Conditional">Conditional</option>
                            <option value="Permanent">Permanent</option>


                        </Field>

                        : ''}</>
            ),
        },
        ...(!userId.startsWith("ffca") ? [
            {
                Header: "Affiliation Valid Up to",
                accessor: (row, index) => (
                    <>
                        {ProeedConfirmdetailsFormik?.values?.newCourses[index]?.univCourseApproved === "true" ?
                            <Field type="date" name={`newCourses[${index}].afflValidUpto`} className="form-control" min={new Date().toISOString().split('T')[0]}
                                onKeyDown={(e) => { e.preventDefault() }} />

                            : ''}</>
                ),

            }] : []),
        {
            Header: !userId.startsWith("ffca")
                ? `Intake being Approved by University for Academic year ${acYear}`
                : `Intake being Approved by FFCA for Academic year ${acYear}`,

            accessor: (row, index) => (
                <>
                    {ProeedConfirmdetailsFormik?.values?.newCourses[index]?.univCourseApproved === "true" ?
                        <Field type="text" name={`newCourses[${index}].finalSanctionIntake`} className="form-control" onKeyPress={(e) => { allowNumbersOnly(e) }} maxLength="5" />
                        : ''}</>

            ),
        },
        {
            Header: !userId.startsWith("ffca")
                ? `Number of Sections being approved by University for Academic year ${acYear}`
                : `Number of Sections being approved by FFCA for Academic year ${acYear}`,
            accessor: (row, index) => (
                <>
                    {ProeedConfirmdetailsFormik?.values?.newCourses[index]?.univCourseApproved === "true" ?
                        <Field type="text" name={`newCourses[${index}].finalNoSection`} onKeyPress={(e) => { allowNumbersOnly(e) }} className="form-control" maxLength="5" />
                        : ''}</>
            ),
        },
        {
            Header: "Campus type",
            accessor: (row, index) => (
                <>
                    <Field as="select" name={`newCourses[${index}].campusType`} className="form-control" >
                        <option value=''> ---select---</option>
                        <option value="main" >Main Campus</option>
                        <option value="off">Off Campus</option>
                    </Field>
                </>
            ),
        },

    ]

    return (
        <>
            <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                <FormikProvider value={ProeedConfirmdetailsFormik}>

                    <Form onChange={ProeedConfirmdetailsFormik?.handleChange} onSubmit={ProeedConfirmdetailsFormik?.handleSubmit} className="affl-form" >
                        <bie.Row className="px-2 pt-3 mb-3">
                            {renewalCourses?.length > 0 && renewalCourses !== "No data found" ? (<>

                                <div className="inner-herbpage-service-title-sub px-0"><h1 className="mb-0">Renewal Courses Report-Submitted by College</h1></div>
                                <div className="table-responsive">

                                    <CommonReactTable data={renewalCourses} columns={CourseDataReportColumns} tableId="table-for-excel1" filename="Renewal Courses Report" headerName="Renewal Courses  Report" paginationCount='All' />
                                </div>
                            </>) : ''}
                            {ffcaNonOamdcCoursesData?.ffcaExistingList?.length > 0 && ffcaNonOamdcCoursesData?.ffcaExistingList !== "No data found" && !userId.startsWith("ffca") ? (<>
                                <div className="inner-herbpage-service-title-sub px-0"><h1 className="mb-0">FFCA Commitee  Recommended Existing Courses  </h1></div>
                                <div className="table-responsive">
                                    {ffcaNonOamdcStatusFlag === true && (<>
                                        <CommonReactTable data={ffcaNonOamdcCoursesData?.ffcaExistingList} columns={FfcaExistingCoursesColumns} filename="FFCA Commitee  Recommended Existing Courses" headerName="FFCA Commitee  Recommended Existing Courses" paginationCount='All' />
                                    </>)}

                                </div>
                            </>) : ''}

                            {(renewalCourses?.length > 0 && existingCourses?.length > 0 && renewalCourses !== "No data found" && existingCourses !== "No data found") ? (<>
                                <div className="inner-herbpage-service-title-sub px-0"><h1 className="mb-0"> Existing Course Details  Confirmation</h1></div>

                                <div className="table-responsive">

                                    <CommonReactTable data={existingCourses} columns={ExistingCoursesColumns} tableId="table-for-excel2" excelFlag={false} printFlag={false} filename="Existing Details Confirmation" headerName={`Existing Details Confirmation`} paginationCount='All' />
                                </div>
                            </>) : ''}

                            {newCourse?.length > 0 && newCourse !== "No data found" ? (
                                <>
                                    <div className="inner-herbpage-service-title-sub"><h1 className="mb-0">New Courses  Report-Submitted by College</h1></div>

                                    <div className="table-responsive">

                                        <CommonReactTable tableId="table-for-excel3" data={newCourse} columns={NewCourseColumns} filename="New Courses  Report" excelFlag={true} headerName="New Courses  Report" paginationCount='All' />
                                    </div></>
                            ) : ''}
                            {ffcaNonOamdcCoursesData?.ffcaNewList?.length > 0 && ffcaNonOamdcCoursesData?.ffcaNewList !== "No data found" && !userId.startsWith("ffca") ? (<>
                                <div className="inner-herbpage-service-title-sub"><h1 className="mb-0">FFCA Commitee  Recommended  New Courses </h1></div>

                                <div className="table-responsive">
                                    {ffcaNonOamdcStatusFlag === true && (<>
                                        <CommonReactTable tableId="table-for-excel4" data={ffcaNonOamdcCoursesData?.ffcaNewList} columns={FfcaCourseConfirmColumns} filename="FFCA Commitee  Recommended New Courses" excelFlag={true} headerName="FFCA Commitee  Recommended New Courses" paginationCount='All' />
                                    </>)}

                                </div>
                            </>
                            ) : ''}
                            {newCourse?.length > 0 && newCourse !== "No data found" && ffcaDataFlag === true ? (
                                <>
                                    <div className="inner-herbpage-service-title-sub"><h1 className="mb-0">New Course Details  Confirmation</h1></div>
                                    <div className="table-responsive">


                                        <CommonReactTable data={newCourseConfirm} columns={NewCourseConfirmColumns} excelFlag={false} printFlag={false} filename=" New Course Details Confirmation" headerName={`New Course Details Confirmation`} paginationCount='All' />
                                    </div>
                                </>
                            ) : ''}

                            <div className="button-cend pt-1 mb-3">
                                {(ffcastatus === "0" || userId?.startsWith("affl")) && (
                                    <div className="button-cend pt-1 mb-3">
                                        <button type="submit" className="btn btn-success mt-2 me-3 float-end mb-2">
                                            Submit
                                        </button>
                                    </div>
                                )}
                                {ffcastatus === "1" && userId?.startsWith("ffca") && (
                                    <button type="button" className='float-end' style={{ color: "brown", fontSize: "20px" }} onClick={() => { GetFacultyDefPDf() }}>Already Submitted  & view PDF  <FaFilePdf size={23} /></button>
                                )}
                            </div>
                        </bie.Row>
                    </Form>
                </FormikProvider>
            </bie.Container>
        </>
    )
}